<template>
  <div id="pagos-header">
    <div id="sig-container" class="full form-horizontal">
      <div class="widget">
        <div
          class="widget-content widget-content-mini themed-background-info text-light-op"
        >
          <span class="float-right text-muted">
            <i class="fa fa-check"></i> </span
          >Importar información para venta de cartera
        </div>
        <div
          class="widget-content border-bottom themed-background-muted text-center"
        >
          <span class="muted-color"
            >Por medio de este modulo se podra obtener la informacion para el
            proceso de venta de cartera.</span
          >
          <hr />
          <div class="row">
            <div class="loader" v-if="loading">
              <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
            </div>
            <div class="col-md-3"></div>
            <div align="center" class="col-md-6">
              <div class="row centrar">
                <label class="btn btn-primary">
                  <i class="fa fa-file-excel-o"></i>
                  <input
                    v-on:change="ventaCartera()"
                    id="archivo"
                    ref="archivo"
                    name="archivo"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                    style="display: none"
                  />
                  Seleccionar archivo
                </label>
                &nbsp;
                <a :href="'../files/formato-venta-cartera.csv'" download>
                  <label class="btn btn-success">
                    <i class="fa fa-file-excel-o"></i>
                    Descargar archivo
                  </label>
                </a>
              </div>
              <div class="row centrar">
                <p>
                  Si tienes el formato listo para la importación podrás montarlo
                  por medio del boton "Seleccionar archivo". En caso, contrario
                  podras descargar el formato base para montar este cargue por
                  medio de "Descargar archivo".
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapGetters({ loading: "ventaCartera/loading" }),
  },
  methods: {
    ventaCartera() {
      this.file = this.$refs.archivo.files[0];
      let formData = new FormData();
      formData.append("datos", this.file);

      this.$store.commit("ventaCartera/setLoading", true);
      this.$store
        .dispatch("ventaCartera/exportar", formData)
        .then((response) => {
          this.$store.commit("ventaCartera/setLoading", false);
          this.$notify({
            title: "Archivo procesado",
            content:
              "Se ha exportado con exito la información para venta de cartera.",
            type: "success",
          });

          saveAs(
            new Blob([response.data.data], { type: "text/csv" }),
            response.data.nombre
          );
        })
        .catch(() => {
          this.$store.commit("cargueGestion/setLoading", false);
          this.$notify({
            title: "Fallo al exportar",
            content:
              "Se produjo un error al tratar de exportar el archivo, por favor inténtelo mas tarde." +
              error,
            type: "danger",
          });
        });
    },
  },
  mounted() {},
};
</script>
<style>
.disponibles {
  display: flow-root !important;
}
.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}
.muted-color {
  color: #b9b9b9;
  font-style: italic;
}

.centrar {
  display: block;
}
</style>
